// 搜索栏获取参数
class searchReq {
  public pageNo: number;
  public pageSize: number;
  public state: string;
  public recUniversity: string;
  public startDate: string;
  public jobName: string;

  constructor() {
    this.pageNo = 1;
    this.pageSize = 20;
    this.startDate = "";
    this.state = "";
    this.recUniversity = "";
    this.startDate = "";
    this.jobName = "";
  }
}

// 简历列表搜索栏参数
class resumeListReq {
  public pageNo: number;
  public pageSize: number;
  public university: string;
  public specificMajor: string;
  public birthPlace: string;
  public jobName: string;
  public state: string;
  public major: string;
  constructor() {
    this.pageNo = 1;
    this.pageSize = 20;
    this.university = "";
    this.specificMajor = "";
    this.birthPlace = "";
    this.jobName = "";
    this.state = "";
    this.major = "";
  }
}
// 简历详情参数
class resumeForm {
  public area: string;
  public attachmentAddress: string;
  public attachmentName: string;
  public birthPlace: string;
  public birthday: string;
  public city: string;
  public education: string;
  public email: string;
  public graduationDate: string;
  public height: string;
  public major: string;
  public name: string;
  public nation: string;
  public phone: string;
  public provinces: string;
  public selfAssessment: string;
  public sex: string;
  public skillsCompetition: string;
  public sno: string;
  public socialPractice: string;
  public specificMajor: string;
  public university: string;
  public weight: string;
  public workingExperience: string;
  public otherPlan: string;
  public remark: string;
  constructor() {
    this.area = "";
    this.attachmentAddress = "";
    this.attachmentName = "";
    this.birthPlace = "";
    this.birthday = "";
    this.major = "";
    this.city = "";
    this.education = "";
    this.email = "";
    this.graduationDate = "";
    this.height = "";
    this.name = "";
    this.nation = "";
    this.phone = "";
    this.provinces = "";
    this.selfAssessment = "";
    this.sex = "";
    this.skillsCompetition = "";
    this.sno = "";
    this.socialPractice = "";
    this.specificMajor = "";
    this.university = "";
    this.weight = "";
    this.workingExperience = "";
    this.otherPlan = "";
    this.remark = "";
  }
}

// 新增行程参数
class addFormData {
  public speechTime: any;
  public university: string;
  public address: string;
  public place: string;
  public regulation: string;
  public startDate: string;

  constructor() {
    this.speechTime = "";
    this.university = "";
    this.address = "";
    this.place = "";
    this.regulation = "";
    this.startDate = "";
  }
}

export { searchReq, addFormData, resumeListReq, resumeForm };
